import { createFileRoute } from '@tanstack/react-router'
import SubmissionIndex from '@/pages/clients/components/submission'

export const Route = createFileRoute(
  '/_authenticated/clients/$clientId/submission/$submissionId'
)({
  component: SubmissionIndex,
})
